import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild} from '@angular/core';

@Component({
  selector: 'app-about-company',
  templateUrl: './about-company.component.html',
  styleUrls: ['./about-company.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutCompanyComponent {
  @ViewChild('about', {static: true}) about: ElementRef;
  items = [
    {
      icon: 'it-icon',
      title: 'С 19 апреля 2019 года',
      info: 'company-info',
      company: 'Аккредитованная ИТ компания.',
      text_before: 'С момента создания предприятие ведет разработку инновационного проекта:«',
      text: 'TravelSys.Pro ',
      text_after: '- роботизированная система управления офлайн и онлайн турагентством на основе процессного подхода».',
    },
    {
      icon: 'flag-icon',
      title: 'Июль 2020 года',
      text_before: 'Запуск пилотного сервиса ',
      text: '“Мои подборки”',
      text_after: '.',
    },
    {
      icon: 'medal-icon',
      title: 'Сентябрь 2020 года',
      text_before: 'Участие в акселераторе Moscow Travel Hub. ',
      text: 'Победители в номинации «B2B трэвел стартапы 2020»',
      text_after: '.'
    },
    {
      icon: 'it-icon',
      title: 'Октябрь 2020 года',
      text_before: 'RUSBASE добавил ',
      text: '"Мои подборки" ',
      text_after: 'на карту TravelTech-рынка России https://rb.ru/traveltech-map Раздел: Провайдерам / Туроператоры / Системы аналитики и автоматизации.',
    },
    {
      icon: 'flag-icon',
      title: 'Ноябрь 2020 года',
      text_before: 'Запуск мобильной версии пилотного сервиса ',
      text: '"Мои подборки"',
      text_after: '.',
    },
    {
      icon: 'medal-icon',
      title: 'Декабрь 2020 года',
      text_before: 'Выиграли грант от Фонда содействия инновациям (программа Старт-1) на разработку сервиса «Заказ Туруслуг» системы ',
      text: 'TravelSys.Pro',
      text_after: '.'
    },
    {
      icon: 'it-icon',
      title: 'Январь 2021 года',
      text_before: 'Успешно пройден курс “Акселератор - Skolkovo Community. Курс предпринимательства, VIII поток.”',
      text: '',
    },
    {
      icon: 'flag-icon',
      title: 'Март 2021 года',
      text_before: 'Финалисты конкурса стартапов MITT Travel Start.',
      text: '',
    },
    {
      icon: 'medal-icon',
      title: 'Январь 2022 года',
      text_before: 'Роспатент зарегистрировал право на программу для ЭВМ «Cервис «Заказ туруслуг», входящий в состав облачной роботизированной системы управления офлайн и онлайн турагентством на основе процессного подхода». Свидетельство № 2022611164.',
      text: '',
    },
    {
      icon: 'it-icon',
      title: 'Октябрь 2022 года',
      text_before: 'Выиграли грант от Фонда содействия инновациям (программа Старт-2) на разработку сервиса «Заказ Туруслуг» системы ',
      text: 'TravelSys.Pro',
      text_after: '.',
    },
    {
      icon: 'medal-icon',
      title: 'Январь 2024 года',
      text_before: 'Роспатент зарегистрировал право на программу для ЭВМ «Cервис «Онлайн бронирование услуг физическими лицами», входящий в состав облачной роботизированной системы управления офлайн и онлайн турагентством на основе процессного подхода». Свидетельство № 2024610783.',
      text: '',
    },
    {
      icon: 'flag-icon',
      title: 'Апрель 2025 года',
      text_before: 'Запуск сервиса ',
      text: '"ТОП.СР", ',
      text_after: 'предназначенного для поиска и группового бронирования номеров в отелях для пассажиров сбойных авиарейсов. Свидетельство о государственной регистрации программы для ЭВМ № 2025618734.',
    },
    {
      icon: 'flag-icon',
      title: 'Август 2025 года',
      text_before: 'Запуск сервиса бронирования отелей для турагентов ',
      text: '"BookHotels.PRO". ',
      text_after: 'В партнерстве с компаниями Комфорт Букинг и Трэвеллайн реализован прямой доступ к ресурсам отелей для онлайн бронирования номеров.',
    },
    {
      icon: 'flag-icon',
      title: 'Январь 2026 года',
      text_before: 'Запуск платформы для B2B-продаж и дистрибуции отелей ',
      text: '"ТОП.B2B"',
      text_bold1: 'Для туроператоров',
      text_dop1: 'Система B2B-бронирования отелей для агентской сети',
      text_bold2: 'Для гостиничных сетей',
      text_dop2: 'Платформа B2B-продаж и управления агентскими и корпоративными тарифами',
      text_bold3: 'Для принимающих компаний',
      text_dop3: 'B2B-портал для работы с зарубежными партнерами',
    },
  ];

  private asyncFlag = false;

  constructor(
    private ref: ChangeDetectorRef,
  ) {
  }

  // Position locator
  private getScrollerElem(): HTMLElement {
    // tslint:disable-next-line:no-non-null-assertion
    return document!.getElementById('about-wrapper')!;
  }

  private scrollerYOffset(): number {
    // tslint:disable-next-line:no-non-null-assertion
    const elem = this.getScrollerElem();
    return (elem.parentElement.offsetTop + elem.offsetTop - 20);
  }

  // Wheel processor
  public onWheel(event: WheelEvent): void {
    if (this.asyncFlag) { return; }
    this.asyncFlag = true;
    try {
      const elem = this.getScrollerElem();
      // tslint:disable-next-line:no-non-null-assertion
      elem.scrollTo({ left:  elem.scrollLeft + event.deltaY! * 5, behavior: 'smooth' });
      // Added -2 to prevent IE issue
      if (((elem.scrollLeft === 0 && event.deltaY < 0)) ||
        ((elem.scrollLeft >= (elem.scrollWidth - elem.clientWidth - 2) && event.deltaY > 0))) { return; }
      event.preventDefault();
    } finally {
      this.asyncFlag = false;
    }
  }

  // Scroll processor
  public async scrollerRollByOffsetPosition(shift: number = null): Promise<void> {
    if (this.asyncFlag) { return; }
    this.asyncFlag = true;
    try {
      // tslint:disable-next-line:no-non-null-assertion
      const elem = this.getScrollerElem();
      // tslint:disable-next-line:no-non-null-assertion
      if (this.scrollerYOffset() <= window.pageYOffset + (shift === null ? elem.clientHeight : shift)) {
        await elem.scrollTo({left: elem.scrollWidth, behavior: 'smooth'});
        return;
      }
      if (this.scrollerYOffset() >= window.pageYOffset) {
        await elem.scrollTo({left: 0, behavior: 'smooth'});
      }
    } finally {
      this.asyncFlag = false;
    }
  }
}


